var map = {
	"./add.svg": 1956,
	"./add_user.svg": 1957,
	"./approval.svg": 1958,
	"./back_filled.svg": 1959,
	"./biggroup.svg": 1960,
	"./book.svg": 1961,
	"./cancel.svg": 1009,
	"./cancel_filled.svg": 1962,
	"./copy.svg": 1963,
	"./delete.svg": 1964,
	"./detail.svg": 1965,
	"./down.svg": 1966,
	"./down_filled.svg": 1967,
	"./download.svg": 1968,
	"./download_filled.svg": 1969,
	"./edit.svg": 1970,
	"./export.svg": 1971,
	"./guide.svg": 1972,
	"./instruction.svg": 1973,
	"./left.svg": 1974,
	"./left_filled.svg": 1975,
	"./listview.svg": 1976,
	"./maximize_filled.svg": 1977,
	"./menu.svg": 1978,
	"./minimize_filled.svg": 1979,
	"./ninedot.svg": 1980,
	"./notification.svg": 1981,
	"./page.svg": 1982,
	"./page_filled.svg": 1983,
	"./pin.svg": 1984,
	"./plus_filled.svg": 1985,
	"./right.svg": 1986,
	"./right_filled.svg": 1987,
	"./save.svg": 1988,
	"./save_filled.svg": 1989,
	"./scan.svg": 1990,
	"./search.svg": 1991,
	"./share.svg": 1992,
	"./smallgroup.svg": 1993,
	"./subtract_filled.svg": 1994,
	"./unpin.svg": 1995,
	"./up.svg": 1996,
	"./up_filled.svg": 1997,
	"./update-info-cancel.svg": 1998,
	"./view.svg": 1999,
	"./waiting.svg": 2000,
	"./warehoure_filled.svg": 2001,
	"./warning.svg": 2002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1955;